import ReactDOM from "react-dom";
import { Fragment, useRef, useEffect, useState } from "react";
import styles from './Modal.module.css'; // Assuming you have a CSS module for styling

const ModalOverlay = (props) => {
  const parentRef = useRef();
  const childRef = useRef();
  const [show, setShow] = useState(false);

  const clickOutsideModalHandler = (e) => {
    if (childRef.current && !childRef.current.contains(e.target)) {
      if (props.onClose) {
        props.onClose();
      }
    }
  };

  useEffect(() => {
    if (props.show) {
      setShow(true);
    } else {
      const timer = setTimeout(() => setShow(false), 300);
      return () => clearTimeout(timer);
    }
  }, [props.show]);

  useEffect(() => {
    document.addEventListener('mousedown', clickOutsideModalHandler);
    return () => document.removeEventListener('mousedown', clickOutsideModalHandler);
  }, []);

  const content = (
    <div
      style={{ backgroundColor: props.bgColor }}
      ref={parentRef}
      className={styles.modal_container}
    >
      <div
        className={`${styles.modal_content_wrapper} ${props.fullSize ? styles.full_width : ''} ${props.show ? styles.modal_show : ''}`}
        ref={childRef}
      >
        {props.children}
      </div>
    </div>
  );

  return show ? ReactDOM.createPortal(content, document.getElementById("modal-hook")) : null;
};

const Modal = (props) => {
  return (
    <Fragment>
      <ModalOverlay {...props} />
    </Fragment>
  );
};

export default Modal;